import request from '@/utils/request'
// 获取上传七牛token
export function getUploadToken(query) {
  return request({
    url: '/common/generateUploadToken/getUploadToken',
    method: 'get',
    params: query
  })
}
//图片上传
export function uploadImg(params) {
  return request.upload({
    url: '/file/base64Upload',
    method: 'post',
    data: params
  })
}